// Libraries
import React from 'react'
import { Typography } from '@material-ui/core'

// Icons
import ErrorIcon from '@material-ui/icons/Error'

// Styles
import stepCotentStyles from './styles'

function StepContent({ title, text }) {
   const classes = stepCotentStyles()
   return (
      <div className={classes.container}>
         <ErrorIcon />
         <Typography className={classes.title}>{title}</Typography>
         <Typography className={classes.content}>{text}</Typography>
      </div>
   )
}

export default StepContent
